export default "__VITE_ASSET__DDFEh9I$__"